import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPCraft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 53,
	viewBox: "0 0 52 53",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4292 45.839C15.4721 46.2395 15.2706 46.6266 14.9179 46.8211L9.7418 49.6767C8.93583 50.1213 8.00797 49.3329 8.31666 48.4658L12.5304 36.6283C12.887 35.6266 14.3536 35.7999 14.4668 36.8571L15.4292 45.839Z",
			fill: "#2AAB9F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.0892 14.6508C48.7474 15.0325 48.7552 15.9802 48.1033 16.3726L40.1081 21.1857C39.4448 21.5851 38.5987 21.1115 38.5924 20.3372L38.5147 10.8424C38.5084 10.0681 39.3465 9.58071 40.0163 9.96916L48.0892 14.6508Z",
			fill: "#2AAB9F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.88 4.99598C18.2598 4.98614 18.6123 5.19233 18.7899 5.52817L34.861 35.9183C35.1172 36.4026 34.9359 37.0029 34.4545 37.2644L29.3535 40.0362C28.8782 40.2945 28.2836 40.1279 28.0116 39.6603L8.84907 6.71079C8.46713 6.05406 8.92813 5.22808 9.68759 5.20839L17.88 4.99598Z",
			fill: "#2AAB9F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.6048 16.183C25.346 15.6924 25.5359 15.0848 26.0281 14.829L36.182 9.55231C36.8477 9.20636 37.6432 9.68943 37.6432 10.4396L37.6432 34.9616C37.6432 36.0051 36.2456 36.3512 35.7587 35.4283L25.6048 16.183Z",
			fill: "#228C82"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.7612 40.0822C27.0461 40.5806 26.8537 41.216 26.3402 41.4727L17.5836 45.8511C16.9571 46.1643 16.211 45.7531 16.1413 45.0561L13.7531 21.1744C13.6457 20.1004 15.0809 19.6416 15.6164 20.5788L26.7612 40.0822Z",
			fill: "#228C82"
		})
	]
});
export default SvgPCraft;
